import { createApp } from 'vue'
import App from './EnvironmentWater.vue'

createApp(App).mount('#app-environment-water')
